import { Skeleton } from "@/components/ui/skeleton";

const FrameworkTargetsSkeleton = () => (
  <div className="space-y-6">
    <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
      <div className="rounded-radius border border-border bg-card p-4">
        <div className="space-y-2">
          <Skeleton className="h-4 w-24" />
          <Skeleton className="h-3 w-48" />
        </div>
        <div className="mt-4 flex flex-wrap gap-2">
          {Array.from({ length: 6 }).map((_, index) => (
            <Skeleton key={`framework-pill-${index}`} className="h-8 w-20" />
          ))}
        </div>
      </div>

      <div className="rounded-radius border border-border bg-card p-4">
        <div className="space-y-3">
          <Skeleton className="h-4 w-24" />
          <Skeleton className="h-10 w-full" />
          <Skeleton className="h-3 w-32" />
        </div>
      </div>
    </div>

    <div className="rounded-radius border border-border bg-card p-4">
      <div className="space-y-3">
        <Skeleton className="h-4 w-36" />
        <Skeleton className="h-10 w-full" />
      </div>
    </div>

    <div className="flex items-center justify-between gap-3">
      <div className="flex flex-wrap gap-2">
        {Array.from({ length: 4 }).map((_, index) => (
          <Skeleton key={`category-pill-${index}`} className="h-8 w-24" />
        ))}
      </div>
      <Skeleton className="h-8 w-28" />
    </div>

    <div className="space-y-4">
      {Array.from({ length: 2 }).map((_, index) => (
        <div
          key={`metric-card-${index}`}
          className="rounded-radius border border-border bg-card p-4"
        >
          <Skeleton className="h-5 w-48" />
          <Skeleton className="mt-2 h-3 w-64" />
          <div className="mt-4 grid gap-3 md:grid-cols-3">
            {Array.from({ length: 3 }).map((__, cellIndex) => (
              <Skeleton
                key={`metric-cell-${index}-${cellIndex}`}
                className="h-10 w-full"
              />
            ))}
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default FrameworkTargetsSkeleton;
